/**
 * The shell on screen at `/dashboard` for the signed-in subject (#2581). A
 * module of its own, apart from `unified-flag.ts`: that one is imported by the
 * embedded route too, where there is no `RoleContext` (no Clerk), and must not
 * carry it.
 */
import { useRole } from '@/contexts/RoleContext';
import { dashboardFor } from '@/lib/route-permissions';
import type { UnifiedView } from './unified-search';
import { unifiedViewOf, useUnifiedDashboardEnabled } from './unified-flag';

/**
 * The shell on screen at `/dashboard` for the signed-in subject, or `null` —
 * the role dashboard. The platform owner keeps their own dashboard, and
 * viewing as an agent keeps the agent's: the personal view reads the caller's
 * own records. One answer for the route and for whatever must know what the
 * route will draw (the help menu's tour).
 */
export function useUnifiedShellView(): UnifiedView | null {
  const { globalRole, isOwner, viewAsRole, access } = useRole();
  const enabled = useUnifiedDashboardEnabled();
  if (isOwner && !viewAsRole) return null;
  const view = unifiedViewOf(dashboardFor(viewAsRole || globalRole, access), enabled);
  return view === 'personal' && viewAsRole ? null : view;
}
